
    $.fn.accordion = function(options) {
        var settings = $.extend({
            autoCollapse: false
        }, options );
        
        var
            $accordion   = $(this),
            blockName    = $accordion.attr('data-block'),
            $items       = $('.' + blockName + '__item', $accordion);
        
       

        // $accordion.on('click', triggerAccordion);
        $accordion.delegate('.' + blockName + '__title', 'click', triggerAccordion);
        
        
        function triggerAccordion(){
            var
            $that         = $(this),
            $parent       = $that.parent(),
            $content      = $parent.children('.' + blockName + '__content--expandable' ), //used to be $that//
            isOpen        = $that.hasClass('open'),
            autoCollapse  = true,
            contentHeight = $content.prop('scrollHeight');
            
            if(isOpen){
            $that.removeClass('open');
            $parent.removeClass('open');
            $content.css('height', contentHeight);
            setTimeout(function(){
                $content.removeClass('open').css('height', '');
            }, 4);
            }else{
            if(settings.autoCollapse){
                //auto collapse open accordions
            }
            $that.addClass('open');
            $parent.addClass('open');
            $content.addClass('open').css('height', contentHeight).one('webkitTransitionEnd', event, function(){
                if(event.propertyName === 'height'){
                $(this).css('height', '');
                }
            });
            }
        }
        };
    
        $(document).ready(function(){
            $('.list__item--expandable').accordion();
        });